<template>
    <Layout header-class="header-left-align" nav-alignment="left">
        <div class="rn-privacy-area rn-section-gap" :class="{ 'text-white': !userLogin, 'text-black': userLogin }">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <SectionTitle text-align="center" :subtitle="$t('Legal.privacy_policy')"
                            :title="$t('Legal.privacy_policy')" data-aos="fade-up" />
                    </div>
                </div>
                <div class="row mt--40">
                    <div class="col-lg-10 offset-lg-1">
                        <div class="content LexenRegular" data-aos="fade-up" data-aos-delay="100">
                            <template v-if="$i18n.locale === 'en'">
                                <h4 :class="{ 'text-white': !userLogin }">1. Overview</h4>
                                <p>
                                    At HubThings, we are committed to protecting your privacy. This Privacy Policy
                                    outlines how we collect, use, and safeguard your personal information when you use
                                    our EV Roaming Hub and related services.
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">2. Information Collection</h4>
                                <p>
                                    We may collect personal information such as your name, email address, phone
                                    number, and charging session data to provide and improve our services.
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">3. Use of Information</h4>
                                <p>
                                    Your information is used to facilitate EV roaming sessions, process payments, and
                                    provide customer support. We do not sell your personal data to third parties.
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">4. Data Security</h4>
                                <p>
                                    We implement industry-standard security measures to protect your data from
                                    unauthorized access, alteration, or disclosure.
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">5. Your Rights</h4>
                                <p>
                                    You have the right to access, correct, or delete your personal information. Please
                                    contact us if you wish to exercise these rights.
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">6. Contact Us</h4>
                                <p>
                                    If you have any questions about this Privacy Policy, please contact us at
                                    evangelist@gridwhiz.io.
                                </p>
                            </template>
                            <template v-else>
                                <h4 :class="{ 'text-white': !userLogin }">1. ภาพรวม</h4>
                                <p>
                                    ที่ HubThings เรามุ่งมั่นที่จะปกป้องความเป็นส่วนตัวของคุณ
                                    นโยบายความเป็นส่วนตัวนี้ระบุถึงวิธีที่เรารวบรวม ใช้
                                    และปกป้องข้อมูลส่วนบุคคลของคุณเมื่อคุณใช้ EV Roaming Hub
                                    และบริการที่เกี่ยวข้องของเรา
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">2. การรวบรวมข้อมูล</h4>
                                <p>
                                    เราอาจรวบรวมข้อมูลส่วนบุคคล เช่น ชื่อ ที่อยู่อีเมล หมายเลขโทรศัพท์
                                    และข้อมูลเซสชันการชาร์จ เพื่อให้บริการและปรับปรุงบริการของเรา
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">3. การใช้ข้อมูล</h4>
                                <p>
                                    ข้อมูลของคุณถูกใช้เพื่ออำนวยความสะดวกในเซสชัน EV roaming ประมวลผลการชำระเงิน
                                    และให้การสนับสนุนลูกค้า เราไม่ขายข้อมูลส่วนบุคคลของคุณให้กับบุคคลที่สาม
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">4. ความปลอดภัยของข้อมูล</h4>
                                <p>
                                    เราใช้มาตรการรักษาความปลอดภัยที่เป็นมาตรฐานอุตสาหกรรมเพื่อปกป้องข้อมูลของคุณจากการเข้าถึง
                                    การแก้ไข หรือการเปิดเผยโดยไม่ได้รับอนุญาต
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">5. สิทธิ์ของคุณ</h4>
                                <p>
                                    คุณมีสิทธิ์ในการเข้าถึง แก้ไข หรือลบข้อมูลส่วนบุคคลของคุณ
                                    โปรดติดต่อเราหากคุณต้องการใช้สิทธิ์เหล่านี้
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">6. ติดต่อเรา</h4>
                                <p>
                                    หากคุณมีคำถามใดๆ เกี่ยวกับนโยบายความเป็นส่วนตัวนี้ โปรดติดต่อเราที่
                                    evangelist@gridwhiz.io
                                </p>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from '../components/common/Layout'
import SectionTitle from '../components/elements/sectionTitle/SectionTitle'
import i18n from '../../i18n/i18n'

export default {
    name: 'PrivacyPolicy',
    i18n,
    components: {
        SectionTitle,
        Layout
    },
    computed: {
        userLogin() {
            return this.$store.state.userLogin
        }
    }
}
</script>

<style scoped>
.rn-privacy-area {
    min-height: 600px;
}

.content h4 {
    margin-top: 30px;
    margin-bottom: 15px;
}

.content p {
    line-height: 1.8;
    margin-bottom: 20px;
}
</style>
